var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.6813C11.8842 20.6813 11.7681 20.6385 11.6778 20.5528C11.0767 19.9821 10.499 19.4367 9.94561 18.9142C2.64728 12.0222 -0.683928 8.87665 1.83133 4.28415C2.92262 2.29168 4.97267 1.03348 7.18152 1.00069C9.11115 0.972703 10.8329 1.84772 12 3.42639C13.1671 1.84761 14.8827 0.971789 16.8185 1.00069C19.0273 1.03348 21.0774 2.29168 22.1687 4.28404C24.6839 8.87665 21.3527 12.0222 14.0544 18.9142C13.501 19.4367 12.9233 19.9821 12.3222 20.5528C12.2319 20.6385 12.1158 20.6813 12 20.6813ZM7.272 1.93592C7.24641 1.93592 7.22105 1.93615 7.19546 1.93649C5.32272 1.96437 3.58183 3.03612 2.65208 4.73371C0.484133 8.69237 3.44199 11.4856 10.5881 18.2337C11.0426 18.6628 11.5133 19.1072 12 19.5685C12.4867 19.1072 12.9574 18.6628 13.4119 18.2337C20.558 11.4856 23.5159 8.69237 21.3479 4.7336C20.4182 3.03612 18.6773 1.96437 16.8045 1.93649C16.779 1.93615 16.7534 1.93592 16.728 1.93592C14.9396 1.93592 13.3666 2.87149 12.4035 4.51208C12.3194 4.65511 12.1659 4.74308 12 4.74308C11.8341 4.74308 11.6806 4.65511 11.5965 4.51207C10.6334 2.8716 9.06043 1.93592 7.272 1.93592Z",
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.51e4c964d19d20f17d40e0d9f8a6d146.svg";
export { ForwardRef as ReactComponent };